import './index.less';
import React, { Component } from 'react';
import { fileAjax } from '../../util/utils';
import { Toast } from 'antd-mobile';
class Uploader extends Component {
    state = {
        loading:false,
        issupportFileChooser:true,
    }  
    componentDidMount(){
        if(typeof(android) !== 'undefined' ){
            if(typeof(supportFileChooser) === 'undefined'){
                this.setState({
                    issupportFileChooser:false
                });
            }
        }
    }
    handClick(){
        Toast.info("由于文件格式限制，请点击右上角按钮，选择在浏览器中打开");
    }
    handChange(){
        this.setState({
            loading:true
        });
        let that = this;
        let file = document.querySelector('#fileInput').files[0];
        let urls = 'https://bbs.360.cn/zt/luyin/fileupload.php';
        let filddata = new FormData();
        filddata.append('Filedata', file);//上传的文件： 键名，键值
        fileAjax(urls,filddata,function(res){
            that.setState({
                loading:false
            });
            Toast.info(res.message)
        });
        
    }
    render(){       
        return (
            <div className="uploader-con clearfix">
                <div className="uploader-dec">
                    <h2>活动介绍<i></i></h2>
                    <p>天气不似预期，亦可在岁月如歌中寻觅。生活也许走走停停，奈何我们无法后退，只好想尽一切办法保持前进。偶然间翻到当初满怀期待写下的to-do-list，再配合余光扫描日历的动作之后才惊觉，2018年，竟也就这么过去了。时光大概就是个幽灵，悄无声息地在你身边游走，可你却怎么也捉不住它。与其在茫然仓促中结束，不如重温这一年的点滴，用声音留住回忆？</p>
                    <p>把你想对18年的自己说的话录制下来，上传到指定的活动页面，入选的小伙伴就能获得精美礼品！期待你的声音！</p>
                </div>
                <div className="uploader-btn">
                    <div className="clearfix uploader-body">
                        <span className="submit">上传录音</span>
                        {
                            this.state.issupportFileChooser ?
                            <input  type="file" id="fileInput"onChange={this.handChange.bind(this)}/>
                            :
                            <input  type="button" id="fileInput" onClick={this.handClick.bind(this)}/>
                        }
                    </div>
                    <p>（支持以下格式：.aac/.mp3/ .m4a/ .ogg/ .wma/ .wav/ .mpeg/ .rar/ .zip）</p>
                </div>
                {
                    this.state.loading?
                    <div className="uploading">
                        <div className="loading">
                            <div id="preloader_2">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <p>文件上传中......</p>
                        </div>
                    </div>
                    : null
                }
            </div>
        )
    }
};
export default Uploader;


// WEBPACK FOOTER //
// ./src/component/upload/index.jsx